import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_VISIBILIDADPDF = `${API_URL}/reconocimientoNivel/comprobarVisibilidadPdf/`;
const GET_RECONOCIMIENTOS = `${API_URL}/reconocimientoNivel/reconocimientos/`;
const GET_SOLOCITUDES_REALIZADAS = `${API_URL}/reconocimientoNivel/obtenerSolicitudesRealizadas/`;
const GET_PDF_SOLICITUD_RECONOCIMIENTO = `${API_URL}/jasper/generarPDF_solicitudes`;
const GET_MENSAJES_RECONOCIMIENTO = `${API_URL}/reconocimientoNivel/mostrarReconocimientosFavorableNivelCarreraProfesional/`;
const GET_PDF_RECONOCIMIENTOS = `${API_URL}/reconocimientoNivel/mostrarReconocimientosFavorableNivelCarreraProfesionalPDF/`;

/**
 * Obtiene si reconocimiento es visible o no
 *
 * @param {String} token
 * @returns data
 */
export async function getVisiblidadPDF(dni) {
  return await axios({
    method: "GET",
    url: `${GET_VISIBILIDADPDF}${dni}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en validar DNI para la visibilidad")
    );
}
/**
 * Obtiene los datos de los reconocimientos
 *
 * @param {String} token
 * @returns data
 */
export async function getReconocimientos(dni) {
  return await axios({
    method: "GET",
    url: `${GET_RECONOCIMIENTOS}${dni}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger los reconocimientos")
    );
}
/**
 * Obtiene los datos de las Solicitudes Realizadas
 *
 * @param {String} token
 * @returns data
 */
export async function getSolicitudesRealizadas(dni) {
  return await axios({
    method: "GET",
    url: `${GET_SOLOCITUDES_REALIZADAS}${dni}`,
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger las solicitudes realizadas")
    );
}

export async function getPDFSolicitud(xwemprecnivcar2021) {
  // 
  // enviar parametros como dni por e.j. para realizar la query en el back
  // 
  return await axios({
    method: "GET",
    url: `${GET_PDF_SOLICITUD_RECONOCIMIENTO}/${xwemprecnivcar2021}`,
    responseType: "blob",
    // params:xwemprecnivcar2021
  }).then((response) => response.data).catch(
    (response) =>
      (response.data = "Error: Fallo en recoger la solicitud del reconocimiento")
  );
}

export async function getMensajesReconocimientos(x_cabactadm) {
  return await axios({
    method: "GET",
    url: `${GET_MENSAJES_RECONOCIMIENTO}${x_cabactadm}`,
    responseType: "blob"  
  })
    .then((response) => response.data)
    .catch(function () { });
}

export async function getPDFReconocimientos(x_cabactadm) {
  return await axios({
    method: "GET",
    responseType: "blob",
    url: `${GET_PDF_RECONOCIMIENTOS}${x_cabactadm}`,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger el PDF del reconocimiento")
    );
}
